import { I18nAvailableLanguage } from '@ahha/i18n/i18n'

import dictKo from '@/assets/dictionary/ko.json'
import dictEn from '@/assets/dictionary/en.json'

const i18nConfig: I18nAvailableLanguage[] = [
  // NOTE : 25.4.9 기준, Admin 에서는 다국어 지원할 예정이 없어 영어 lang 옵션을 주석 처리했음.
  // {
  //   language: 'en',
  //   dictionary: dictEn,
  //   language_display_name: 'English',
  // },
  {
    language: 'ko',
    dictionary: dictKo,
    language_display_name: '한국어',
  },
]

export default i18nConfig
